import React from 'react';
import { Star } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="pt-6 pb-6 px-4 md:px-8 max-w-5xl mx-auto text-center" data-id="element-63">
      <h1 className="font-display font-black text-4xl md:text-6xl lg:text-7xl text-ink leading-tight mb-6 tracking-tight" data-id="element-64">
        Corré con una mente <br className="hidden md:block" data-id="element-65" />
        <span className="text-forest" data-id="element-66">tan fuerte como tus piernas</span>
      </h1>

      <a href="https://checkout.ebookbtnlines.shop/cart/45562585514031:1" aria-label="Comprar Mindfulness para Runners" className="block w-full max-w-3xl mx-auto -mb-4 relative z-10 cursor-pointer" data-id="element-67">
        <img src="https://cdn.magicpatterns.com/uploads/tB9RLKdP4VwfQNXNHoQJey/mindfulness_para_runners_SIN_FONDO.png" alt="Mindfulness para Runners Bundle" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-68" />
      </a>

      <div className="bg-sage-soft rounded-3xl p-8 md:p-12 pt-16 md:pt-20 -mt-12 relative z-0" data-id="element-69">
        <p className="text-lg md:text-xl font-medium text-ink/80 max-w-2xl mx-auto mb-8 leading-snug" data-id="element-70">
          Mindfulness, respiración y herramientas psicológicas para correr con
          más foco y mayor resistencia mental.
        </p>

        <div className="flex items-center justify-center gap-1 mb-8" data-id="element-71">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-yellow-400 text-yellow-400" data-id="element-72" />)}
          <span className="ml-2 font-bold text-ink" data-id="element-73">4.9/5 estrellas</span>
        </div>

        <div className="flex flex-col items-center gap-4" data-id="element-74">
          <CTAButton data-id="element-75" />
          <p className="text-forest-dark font-semibold flex items-center gap-2" data-id="element-76">
            <span data-id="element-77">🔥</span> Oferta especial por tiempo limitado
          </p>
        </div>
      </div>
    </section>;
}